import React from 'react'
import { arrayOf, shape, string } from 'prop-types'
import groupBy from 'lodash/groupBy'

import styles from './styles'

const WorkplacePolicyLocations = ({ cities = [] }) => {
  const sortedCities = cities.sort((city1, city2) => city1.name.localeCompare(city2.name))
  const groupedByCountry = groupBy(sortedCities, 'countryName')
  const sortedCountryNames = Object.keys(groupedByCountry).sort((name1, name2) => name1.localeCompare(name2))

  return (
    <If condition={cities.length > 0}>
      <ul className={styles.locationsList}>
        <For each="countryName" of={sortedCountryNames}>
          <li key={countryName}>
            <b>{countryName}:</b>{' '}
            <ul className={styles.cityList}>
              <For each="city" of={groupedByCountry[countryName]}>
                <li key={city.name}>{city.name}</li>
              </For>
            </ul>
          </li>
        </For>
      </ul>
    </If>
  )
}

WorkplacePolicyLocations.propTypes = {
  cities: arrayOf(
    shape({
      countryName: string,
      name: string,
    }),
  ),
}

export default WorkplacePolicyLocations
